import {
    queryClient,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";

import { UserTagCategoryOverview, UserTagOverview } from "api/generated/model";
import {
    getGetTagsQueryKey,
    getGetTagsQueryOptions,
    GetTagsQueryResult,
    useGetTags,
    useGetTagsSuspense,
} from "api/generated/tags/tags";

export interface TagsQuerySelect {
    tags: UserTagOverview[];
    tagCategories: UserTagCategoryOverview[];
}

export const TAGS_QUERY_KEY = getGetTagsQueryKey();
export function useTagsQuery() {
    return useGetTags({
        query: {
            select: toTagsQuerySelect,
            retry: true,
            staleTime: STALE_TIME_RESOURCES,
            refetchOnWindowFocus: true,
        },
    });
}

export function useTagsSuspenseQuery() {
    return useGetTagsSuspense({
        query: {
            select: toTagsQuerySelect,
            retry: true,
            staleTime: STALE_TIME_RESOURCES,
            refetchOnWindowFocus: true,
        },
    });
}

export function invalidateTagsQuery() {
    return queryClient.invalidateQueries({
        queryKey: TAGS_QUERY_KEY,
    });
}

export function fetchTagsQuery() {
    return queryClient
        .fetchQuery(getGetTagsQueryOptions())
        .then(toTagsQuerySelect);
}

/**
 * Maps in `select` so the cache keeps the raw response, which `useGetTags`
 * readers of the same key expect.
 */
function toTagsQuerySelect(response: GetTagsQueryResult): TagsQuerySelect {
    return {
        tags: response.data.content.map((content) => content.resource),
        tagCategories: response.data.linkedResources,
    };
}
